import React, { useState, useEffect, useRef } from 'react';
import '../view-archer-styles.css';

//material UI
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material/';
import { deepOrange, green, pink, blue, red } from '@mui/material/colors';
import { Drafts, Add, AddCircleOutline, Email } from '@mui/icons-material/';

//components import
import FlaggedItem from '../dataObjects/FlaggedItem';
import ReportItem from '../dataObjects/ReportItem';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import AlertInfo from '../../../dataObjects/AlertInfo';

interface ReportItemsTableProps {
    issueId: number;
    reportItems: ReportItem[];
    recordItemType: string;
    addFlaggedItem: (item: FlaggedItem) => void;
    updateSorting: (field: string, direction: string) => void;
}

///to be updated
const receiptRelatedSchedule = ['A', 'C', 'CCI'];
const expenditureRelatedSchedule = ['B', 'D', 'R1'];
const reportRelatedSchedule = ['SV', 'SV1', 'R', 'CC', '102', '105']

const ReportItemsTable = (props: ReportItemsTableProps) => {

    useEffect(() => {
        setSchedule();
    }, [props.recordItemType]);

    const [isReceiptsRelated, setReceiptsRelated] = useState(false);
    const [isExpendituresRelated, setExpendituresRelated] = useState(false);
    const [isReportsRelated, setReportsRelated] = useState(false);

    const [sortDirection, setSortDirection] = useState('');

    const setSchedule = () => {
        let type = props.recordItemType;
        if (receiptRelatedSchedule.includes(type)) {
            setReceiptsRelated(true);
            setExpendituresRelated(false);
            setReportsRelated(false);
        }
        if (expenditureRelatedSchedule.includes(type)) {
            setExpendituresRelated(true);
            setReceiptsRelated(false);
            setReportsRelated(false);
        }
        if (reportRelatedSchedule.includes(type)) {
            setReportsRelated(true);
            setExpendituresRelated(false);
            setReceiptsRelated(false);
        }
    }

    const addFlaggedItem = (item: ReportItem) => {
        var params = [
            `issueId=${props.issueId}`,
            `reportId=${item.reportId}`,
            `itemId=${item.itemId}`,
        ].join('&');
        let url = `/Archer3/addFlaggedItem?${params}`
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: AddFlaggedItem',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    let item = result.result;
                    props.addFlaggedItem(item);
                }
            })
    }

    const updateSorting = (field: string) => {
        let direction = sortDirection === 'desc' ? 'asc' : 'desc';
        setSortDirection(direction);
        props.updateSorting(field, sortDirection);
    }

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <>
            <TableContainer sx={{ maxHeight: 450 }}>
                <Table stickyHeader sx={{ maxWidth: "100%" }} size="small" aria-label="report items table" className="report-items-table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Type</TableCell>
                            <TableCell className="is-clickable" align="right" onClick={() => updateSorting('date')}>Date</TableCell>
                            <TableCell className="is-clickable" align="right" onClick={() => updateSorting('name')}>Name, Address</TableCell>
                            {isReceiptsRelated &&
                                <TableCell align="right">Occupation</TableCell>
                            }
                            {isReceiptsRelated &&
                                <TableCell align="right">Employer</TableCell>
                            }
                            <TableCell align="right">Description</TableCell>
                            <TableCell className="is-clickable" align="right" onClick={() => updateSorting('amount')}>Amount</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.reportItems.map((item) => (
                            <TableRow
                                key={item.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="right">{item.recordTypeDescription}</TableCell>
                                <TableCell component="th" scope="row">
                                    {item.date}
                                </TableCell>
                                <TableCell align="right"><span className="item-name">{item.name}</span> <div>{item.fullAddress}</div></TableCell>
                                {isReceiptsRelated &&
                                    <TableCell align="right">{item.occupation}</TableCell>
                                }
                                {isReceiptsRelated &&
                                    <TableCell align="right">{item.employer}</TableCell>
                                }
                                <TableCell align="right">{item.description} <i className="clarified-purpose">{item.clarifiedPurpose}</i></TableCell>
                                <TableCell align="right">{item.amount}</TableCell>
                                <TableCell align="right">
                                    <IconButton color="success" aria-label="Add Flagged Items" size="small" sx={{ m: 0 }} onClick={() => addFlaggedItem(item)}>
                                        <Add />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </>
    )
}

export default ReportItemsTable